var Curriculog = window.Curriculog || {};

/**
 * Simple multiselctable plugin. It's the lazy programmer version of
 * jQueryUI selectable, but with multiple selections.
 * It should probably take some options or something.
 */
$.fn.multiSelectable = function () {
	this.addClass('multiselectable');
	this.on('click', 'li', function () {
		$(this).toggleClass('active');
	});
	return this;
};

var verticalStretch = function() {
	if (app.formView) {
		Backbone.trigger('form:stretch');
		return;
	}
	var col1 = '#curriculog-fields-column-content';
	var col2 = '#curriculog-steps-column-content';
	// Catch this error so we don't have to include dom.js as a dependency
	// when unit testing.
	try {
		dom().verticalStretchForm(col1, col2);
	} catch (error) {
		// ReferenceError: dom is not defined
	}
};

// This is the standard error message text when any error occurs
var errorMsg = ' Your change was not saved. <br>Please click Continue ' +
				'and try your change again. <br><br>This problem has been ' +
				'reported.';

// This is for getting the value of a contenteditable div with `.val()`
// See https://github.com/jquery/jquery/blob/master/src/attributes/val.js
$.valHooks.div = {
	get: function (elem) {
		return $(elem).html();
	}
};




//
// Models & Collections
//


/**
 * Curriculum is a model for all types of curriculum: programs, courses, cores
 * and custom-text.
 */
Curriculog.Curriculum = Backbone.Model.extend({
	defaults: function () {
		return {
			parents: [],
			children: [],
			isRichText: this.collection.richText
		};
	},

	url: function () {
		var id = this.get('id') ? this.get('id') : '';
		var proposalID = $('#proposalId').val();
		return '/rest/curriculum/' + id + '?proposalID=' + proposalID;
	},

	initialize: function (options) {
		this.parents = [options.parent];
		if (! this.collection) {
			throw Error('Models must have a collection. No exceptions.');
		}
	},


	sync: function (method, model, options) {
    options.attrs = _.omit(model.attributes, 'displayStatus');
    return Backbone.sync.call(this, method, model, options);
  },

	displayName: function () {
		if (this.get('type') === 'course') {
			return [
				this.get('prefix'),
				this.get('code'),
				this.get('name')
			].join(' - ');
		} else {
			return this.get('name');
		}
	},

	/**
	 * Get child curriculum items optionally filtered to match one of the types
	 * passed as arguments.
	 *
	 * This function is intentionally designed to give us duplicates so that we
	 * can build the course list.
	 */
	children: function (/* types */) {
		var children = this.get('children'),
			types = arguments,
			childObjects = [];

		var i, model;
		for (i = 0; i < children.length; i++) {
			model = this.collection.get(children[i]);

			if (! model) {
				continue;
			}
			if (types.length && ! _.contains(types, model.get('type'))) {
				continue;
			}
			childObjects.push(model);
		}
		return childObjects;
	},

	subCores: function () {
		return this.children('core');
	},

	courseList: function () {
		return this.children('course', 'custom');
	},

	// FIXME: for the following four methods, we need to validate that the
	// ids passed as arguments are actually in the collection.

	updateChildCores: function (idList, options) {
		childrenIDs = idList.concat(_.pluck(this.courseList(), 'id'));
		return this.set('children', childrenIDs, options);
	},

	updateCourseList: function (idList, options) {
		childrenIDs = idList.concat(_.pluck(this.subCores(), 'id'));
		return this.set('children', childrenIDs, options);
	},

	removeChild: function (id, options) {
		var children = this.get('children');
		var filteredChildren = _.without(children, id);
		if (! _.isEqual(children, filteredChildren)) {
			this.set('children', filteredChildren, options);
		}
		return this;
	},

	addChild: function (id, options) {
		var children = this.get('children').concat(id);
		return this.set('children', children, options);
	},

	/**
	 * Get the first parent in the list of parents.
	 */
	parent: function () {
		var parents = this.get('parents');
		if (parents.length) {
			return this.collection.get(parents[0]);
		} else {
			return null;
		}
	},

	/**
	 * Returns a hierarchichal JSON object of the whole curriculum.
	 * @return {Object}
	 */
	hierarchy: function () {
		var root = this.toJSON();
		root.cores = _.invoke(this.subCores(), 'hierarchy');
		root.courses = _.map(this.courseList(), function (model) {
			var json = model.toJSON();
			json.isCustomText = model.get('type') === 'custom';
			// json.description = (model.get('type') === 'custom') ? tracking().permalinks(item.get('description')) : json.description;
			return json;
		});
		return root;
	},

	/**
	 * Munge data for the CurriculumTrackingView.
	 * @param  {Boolean} isRoot [description]
	 * @return {[type]}         [description]
	 */
	trackedHierarchy: function (isRoot) {
		// Add the additional attributes that we need for the template.
		tracking().decode(this);

		var isRoot = isRoot || true;
		var data = this.toJSON();

		// Recurse by invoking this function for each subCore.
		data.cores = _.invoke(this.subCores(), 'trackedHierarchy', false);

		// Only include the bucket with the root record of the hierarchy.
		if (isRoot) {
			var courses = _.invoke(this.collection.courses(), 'toJSON');
			var sorted = _.sortBy(courses, function (course) {
				return [course.prefix, course.code, course.name].join(' - ');
			});
			data.bucket = sorted;
		}

		// Return early if we don't have to munge the courseList.
		var courseList = this.courseList();
		if (!courseList.length) {
			data.hasCourses = false;
			return data;
		}
		data.hasCourses = true;
		data.courses = _.map(courseList, function (course) {
			course = tracking().decode(course);

			// determine the relationship status of this course
			course = tracking().decodeRelationship(course, data);

			return course.toJSON();
		});

		return data;
	}
});




/**
 * Curricula is the collection for curriculum.
 */
Curriculog.Curricula = Backbone.Collection.extend({
	model: Curriculog.Curriculum,

	// We immediately transform the data using backboneJS's parse function
	// to add a displayStatus attribute determining whether to display the status
	parse: function(data) {
		var displayCurriculumStatus = this.displayPreviewStatus !== undefined ? this.displayPreviewStatus : $('#displayCurriculumStatus').val() == 1;
		var transformedData = _.map( data, function(item) {
			if ( item.type === 'core' ) {
				item.displayStatus = (displayCurriculumStatus === true && ['Inactive-Hidden', 'Active-Hidden'].indexOf(item.status) !== -1 ) ? item.status : null;
			}
			if ( item.type === 'course' ) {
				item.displayStatus = ( displayCurriculumStatus === true && item.status === 'Inactive-Hidden' );
			}
			return item;
		});
		return transformedData;
	},

	initialize: function (options) {
		options = options || {};
		this.edits = options.edits;
		this.richText = options.richText;
		this.active = options.active;
		this.canImport = options.canImport;
		this.proposalID = options.proposalID || $('#proposalId').val();
		this.displayPreviewStatus = options.displayPreviewStatus;
		$('body').mask('Loading the proposal');

		// trigger a custom method for each type of curriculum
		// add:core, add:course, etc.
		var collection = this;
		this.on('add', function (model, options) {
			var type = model.get('type');
			if (type) {
				collection.trigger('add:' + type, model, options);
			}
		});

		this.on('remove', function (model, options) {
			var removed = model;
			var modified = this.each(function (model) {
				model.removeChild(removed.id, {silent: true});
			});
		});
	},

	url: function () {
		var params = {
			proposalID: this.proposalID
		};

		if (this.edits !== undefined) {
			params.edits = this.edits;
		}

		if (this.active !== undefined) {
			params.active = this.active;
		}

		return '/rest/curriculum?' + $.param( params );
	},

	byType: function (type, callback) {
		var models = this.where({type: type});
		if (callback) {
			_.each(models, callback);
		}
		$('body').unmask();
		return models;
	},

	cores: function (callback) {
		return this.byType('core', callback);
	},

	courses: function (callback) {
		return this.byType('course', callback);
	},

	root: function () {
		return this.find(function (model) {
			return model.get('type') === 'program';
		});
	}
});




//
// Views
//


/**
 * Base class for CurriculumView and StaticCurriculumView.
 * Just contains the tab buttons for now.
 */
Curriculog.BaseCurriculum = Backbone.View.extend({
	events: {
		'click .show-schema': 'showSchema',
		'click .show-courses': 'showCourses',
		'click .preview-curriculum': 'previewCurriculum',
	},

	showCourses: function () {
		this.$('.show-schema').removeClass('active');
		this.$('.show-courses').addClass('active');
		this.$('.schema').hide();
		this.$('.courses').show();
		// FIXME
		verticalStretch();
	},

	showSchema: function () {
		this.$('.show-schema').addClass('active');
		this.$('.show-courses').removeClass('active');
		this.$('.schema').show();
		this.$('.courses').hide();
		// FIXME
		verticalStretch();
	},

	previewCurriculum: function () {
		new Curriculog.PopupWindow({url: '/curriculumPreview.html'});
	},

	/**
	 * Change detection interface.
	 *
	 * @returns {Boolean} Whether or not this curriculum object has unsaved changes.
	 */
	hasUnsavedChanges: function () {
		return false;
	}
});



/**
 * A static view of all the curriculum hierarchy, that uses a recursive template
 * instead of initializing sub-views.
 * Template: staticCurriculum.mustache
 */
Curriculog.StaticCurriculum = Curriculog.BaseCurriculum.extend({
	_events: {
		'click .core-header': 'showHideCore',
	},

	events: function () {
		// FIXME: If we didn't have to call the superclass by name, then this
		// method could be inheritable. Right now it's duplicated in each class.
		var proto = Curriculog.BaseCurriculum.prototype;
		var superEvents = _.result(proto, 'events');
		return _.extend(superEvents, this._events);
	},

	initialize: function (options) {
		this.displayText = options.displayText;
		this.helpText = options.helpText;
    this.cui_enabled = options.cui_enabled;
		this.collection = new Curriculog.Curricula(options);
		this.listenTo(this.collection, 'change', this.render);
		this.listenTo(this.collection, 'reset', this.render);
		this.collection.fetch({reset: true});
	},

	render: function () {
		var data = this.collection.root().trackedHierarchy();
		data.displayText = this.displayText;
		data.helpText = this.helpText;
    data.cui_enabled = this.cui_enabled;
		var partials = _.pick(templates, [
			'staticCoreList',
			'staticCourseList',
			'staticCourse',
			'staticCustomText',
			'staticActivityLog'
		]);
		var el = $(templates.staticCurriculum.render(data, partials));
		this.$el.replaceWith(el);
		this.setElement(el);

		// if there are no cores or courses, add default message
		// remove this hacky 'original' test when old proposals are retired!
		if ( (! $('.core-list li').length) && ($('#view-mode').val() == 'original') ) {
			$('.core-list').append('<li class="no-data">This proposal was created prior to version 1.3.0 of Curriculog. The original state of the curriculum was not tracked prior to this version and is not available.</li>');
		}
		if ( (! $('.course-list li').length) && ($('#view-mode').val() == 'original') ) {
			$('.course-list').append('<li class="no-data">This proposal was created prior to version 1.3.0 of Curriculog. The original state of the curriculum was not tracked prior to this version and is not available.</li>');
		}
		if ( (! $('.core-list li').length) && ($('#view-mode').val() != 'original') ) {
			$('.core-list').append('<li class="no-data">This proposal has no cores.</li>');
		}
		if ( (! $('.course-list li').length) && ($('#view-mode').val() != 'original') ) {
			$('.course-list').append('<li class="no-data">This proposal has no courses.</li>');
		}

		this.showCourses();
		verticalStretch();
		proposal().initMarkupTooltips();

		return this;
	},

	showHideCore: function (event) {
		event.stopImmediatePropagation();
		$(event.target)
			.parents('.core')
			.eq(0)
			.toggleClass('collapsed');
		verticalStretch();
	}
});




/**
 * CurriculumView is the Prospective Curriculum field of a program proposal.
 * Template: curriculum.mustache
 * Subviews: CoreView, CourseList
 */
Curriculog.CurriculumView = Curriculog.BaseCurriculum.extend({
	// This view needs no data to render, so we can set `el` here.
	el: templates.curriculum.render(),
	_events: {
		// Core events
		'click .add-core': 'newCore',
		'click .import-core': 'importCore',
		'click .done': 'reloadStaticView',
		'sortupdate': 'sortCore',
		'sortstart': 'beforeSort'
	},

	events: function () {
		var proto = Curriculog.BaseCurriculum.prototype;
		var superEvents = _.result(proto, 'events');
		return _.extend(superEvents, this._events);
	},

	initialize: function (options) {
		options = options || {};
		this.displayText = options.displayText;
		this.helpText = options.helpText;
		this.canImport = options.canImport;
		this.fieldView = options.fieldView;
		this.richText = options.richText;
    this.cui_enabled = options.cui_enabled;
		this.core_list = [];
		this.$el.mask('Loading...');

		this.showCourses();
		this.proposalID = $('#proposalId').val();
		this.collection = new Curriculog.Curricula(options);

		this.listenTo(this.collection, 'add:core', this.addCore);
		this.listenTo(this.collection, 'reset', this.render);

		// Perform the initial fetch and trigger the reset event when complete.
		var view = this;
		var xhr = this.collection.fetch({
			reset: true,
			success: function (collection) {
				// FIXME:
				// This callback is for the program courselist. Can we somehow
				// move this logic into the CourseList view?
				view.model = collection.root();
				view.listenTo(view.model, 'change:children', view.renderProgramCourseList);
				// FIXME: this doesn't need to render the whole thing. I think we are leaking
				// memory if we switch back and forth repeatedly. We need to make sure that
				// we are cleaning up views.
				view.listenTo(view.model, 'change:type', view.render);
			}
		});
	},

	render: function () {
		var data = {
      'displayText': this.displayText,
      'helpText': this.helpText,
      'cui_enabled': this.cui_enabled
    };
		var el = $(templates.curriculum.render(data));
		this.$el.replaceWith(el);
		this.setElement(el);
		this.showCourses();


		// Render the sub-views.
		this.core_list = [];
		this.renderCoreList();
		this.renderCourseList();
		this.renderProgramCourseList();

		// if no import capability, remove import buttons
		if (! this.canImport) {
			$('fieldset.curriculum').find('.import-course').remove();
			$('fieldset.curriculum').find('.import-core').remove();
			// this.$el.find('.courses button.import-course').remove();
			// this.$el.find('.schema button.import-core').remove();
		}

		verticalStretch();
		return this;
	},

	renderCoreList: function () {
		this.core_list = [];
		_.each(this.collection.root().subCores(), this.addCore, this);
		this.$('.core-list').nestedSortable({
			listType: 'ol',
			placeholder: 'core-sortable-highlight',
			handle: '.core-drag-handle',
			items: 'li.core',
			toleranceElement: 'fieldset',
			disableNesting: 'core-locked',
			listClass: 'sub-cores'
		});
	},

	renderCourseList: function () {
		var collection = this.collection.courses(),
			courseList = new Curriculog.CourseBucket({
				collection: this.collection,
				parentView: this,
				fieldView: this.fieldView
			});
		this.$('.courses').append(courseList.el);
	},

	renderProgramCourseList: function () {
		var courseList = new Curriculog.CourseList({
			// FIXME: `this.model` is undefined because we render before
			// this model can be set in `this.initialize`.
			model: this.model,
			collection: this.collection,
			parentView: this,
		});
		this.$('.schema > .course-list-container').replaceWith(courseList.el);
	},

	newCore: function () {
		var view = this;
		var core = this.collection.create({
			name: 'New Core',
			type: 'core',
			proposal: this.proposalID,
			parents: [this.collection.root().id],
			description: ''
		},{
			wait: true,
			// FIXME There must be a better way.
			success: function (response) {
				//view.collection.root().addChild(response.id).save();
				view.collection.root().addChild(response.id);
			},
			error: function (model, response, options) {

				var messages = {
						'response': response.responseText,
						'default': 'There was an error adding a new core.' + errorMsg
					};

				msg_title = getErrorMessage(messages);

				ErrorDialog = Curriculog.WarningDialog.extend({
					title: msg_title['title'],
					message: msg_title['msg'],
					buttons: {
						'Continue': 'close',
					}
				});
				new ErrorDialog();
			}
		});
	},

	addCore: function (model) {
		var coreView = new Curriculog.CoreView({
			model: model,
			parentView: this
		});

		this.core_list.push(coreView);
		this.$('.core-list').append(coreView.el);
	},

	saveAll: function (event) {
		event && event.stopPropagation();
		var promises = _.invoke(this.core_list, 'save');
		return $.when.apply($, promises);
	},

	hasUnsavedChanges: function () {
		return Boolean(_.filter(_.invoke(this.core_list, 'hasUnsavedChanges')).length);
	},

	applyUnsavedColor: function () {
		if (this.hasUnsavedChanges()) {
			this.$el.addClass('field-unsaved');
		} else {
			this.$el.removeClass('field-unsaved');
		}
	},

	importCore: function (event) {
		var params = {
			display: 'hermesAvailableLegend',
			method: 'core',
			systemItemId: $('#approvalProcessId').val(),
			type: 'program',
			id: 0,
			proposalId: $('#proposalId').val(),
			subType: 'sharedcores'
		};
		var url = '/hermes?' + $.param(params);
		hermesObject.loadWindow(url);
	},

	reloadStaticView: function (event) {
		this.fieldView.cancel(event);
	},

	beforeSort: function (event, ui) {
		var targetItem = $(ui.item);
		var targetID = targetItem.data('id');
		var listItems = targetItem.parent().children().toArray();
		this.oldChildren = listItems.map(function (item) {
				return + item.dataset.id;
			});
	},

	sortCore: function (event, ui) {
		event.stopImmediatePropagation();
		// FIXME: I think we can get some of this data from the `ui` arg.
		var coreEl = $(ui.item.closest('.core'));
		var coreID = coreEl.data('id');
		var coreView = coreEl.data('view');
		var coreModel = this.collection.get(coreID);
		var oldParent = coreModel.parent();
		var newParent = coreView.domParent();

		if (oldParent.id !== newParent.id) {
			// update oldParent children
			oldParent.removeChild(coreID, {silent: true});
		}

		// update newParent children
		var newChildren = Curriculog.CoreView.domChildren(newParent);
		newParent.updateChildCores(newChildren, {silent: true});

		// Update the core, sending the special sort key, so that the backend
		// will know to perform the same operations as we did above.
		//
		// Backbone.js' default behavior is to send a request for each model
		// that needs to be updated. So we originally would send a request to
		// update the oldParent's children, newParent's children, and the target
		// item's parents. Since our backend is also asyncrounous, somtimes
		// these would execute out of order and we would re-render with the
		// wrong data. So, that's why we send the sort key. It eleminates two
		// additional requests and ensures that things don't get out of order.
		var sort = {
			oldParent: oldParent.get('id'),
			newParent: newParent.get('id'),
			newChildren: newParent.get('children')
		};
		var view = this;
		coreModel.set().save({sort: sort, parents: [newParent.id]}, {
			error: function (model, response, options) {

				var messages = {
						'response': response.responseText,
						'default': 'There was an error sorting the cores.' + errorMsg
					};

				msg_title = getErrorMessage(messages);

				ErrorDialog = Curriculog.WarningDialog.extend({
					title: msg_title['title'],
					message: msg_title['msg'],
					buttons: {
						'Continue': 'close',
					}
				});
				new ErrorDialog();
				coreView.remove();
				newParent.removeChild(coreID, {silent: true});
				var newChildren = Curriculog.CoreView.domChildren(newParent);
				newParent.updateChildCores(newChildren, {silent: true});

				oldParent.addChild(coreID, {silent: true});
				oldParent.updateChildCores(view.oldChildren, {silent: true});

				view.render();
				view.showSchema();
			}
		});
		// Remove sort attribute from the backbone model so it not sent with other updates
		coreModel.unset('sort', {silent: true});
	}
});


//
/**
 * Acalog Specific hacks go in this class.
 */
Curriculog.AcalogCurriculumView = Curriculog.CurriculumView.extend({
	// Extend the events object.
	_events: {
		//'sortbeforestop': 'revertLockedCore',
	},

	events: function () {
		var proto = Curriculog.CurriculumView.prototype;
		var superEvents = _.result(proto, 'events');
		return _.extend(superEvents, this._events);
	},

	initialize: function (options) {
		Curriculog.CurriculumView.prototype.initialize.call(this, options);
		this.richText = options.richText;
    this.cui_enabled = options.cui_enabled;
		this.core_list = [];
		// Listen to the programType field
		// // var view = this;
		// // view.model = this.collection.root();
		// var fn = _.bind(this.changeProgramType, this);
		// $('body').on('change', '.programType input[type="radio"]', fn);
		this.listenTo(Backbone, 'change:programType', this.changeProgramType);
	},

	renderProgramCourseList: function () {
		var model = this.collection.root();
		if (model.get('locked') === 1) {
			Curriculog.CurriculumView.prototype.renderProgramCourseList.call(this);
		}
		verticalStretch();
	},

	changeProgramType: function (programType) {
		var view = this;
		var model = this.collection.root();
		// if program (0), locked should be 0
		// if shared core (1), locked should be 1
		var isSharedCore = {
			'0': 0,
			'1': 1
		};
		var selectedType = isSharedCore[programType];
		var currentType = model.get('type');
		if (selectedType === currentType) {
			return;
		}
		model.set('locked', selectedType).save();
		if (model.get('locked') === 1) {
			this.renderProgramCourseList();
		} else {
			var courseList = $(this.el).find('.schema > .course-list-container');
			courseList.hide();
		}

		// if there is something imported already, delete that completely
	},

	/**
	 * Locked cores can't have items nested under them
	 * and they must remain on the root level.
	 */
	renderCoreList: function () {
		this.core_list = [];
		_.each(this.collection.root().subCores(), this.addCore, this);
		this.$('.core-list').nestedSortable({
			listType: 'ol',
			placeholder: 'core-sortable-highlight',
			handle: '.core-drag-handle',
			items: 'li.core',
			toleranceElement: 'fieldset',
			listClass: 'sub-cores',
			isAllowed: function(item, parent) {
				if (
					((item.hasClass('core-locked')) && (parent !== null)) ||
					((! item.hasClass('core-locked')) && (parent !== null) && (parent.hasClass('core-locked')))
				) {
					if (! $('#growls').html().length) {
						$('#growls').notify('create', 'warning-template', {
							title: 'This is a Shared Core',
							text: 'Shared Cores must always be first level cores and cannot be subcores.'
						});
					}
					return false;
				}
				return true;
			}
		});

		_.map(this.$('.core-list .core-locked'), function(lockedCore) {
			// // if not rich text, convert description div to textarea
			// if (! this.richText) {
			// 	var description = $.trim($(lockedCore).find('.core-description-field:eq(0)').text());
			// 	$(lockedCore).find('.core-description-field:eq(0)')
			// 		.replaceWith('<textarea disabled="disabled">' + description + '</textarea>');
			// }
			// if nested shared core, remove ability to delete and drag
			if (! $(lockedCore).parent().hasClass('core-list')) {
				$(lockedCore).find('.btn-delete').remove();
				$(lockedCore).find('.core-drag-handle').remove();
			}
		});

	},

	addCore: function (model) {
		if (model.get('locked')) {
			coreClass = Curriculog.AcalogStaticCoreView;
		} else {
			coreClass = Curriculog.CoreView;
		}

		coreView = new coreClass({
			model: model,
			parentView: this
		});
		this.core_list.push(coreView);
		this.$('.core-list').append(coreView.el);
	}
});


/**
 * An Acalog view of static curriculum, that removes the course list if the item
 * is not a locked (shared) core.
 * Template: staticCurriculum.mustache
 */
Curriculog.AcalogStaticCurriculum = Curriculog.StaticCurriculum.extend({
	render: function() {
		Curriculog.StaticCurriculum.prototype.render.call(this);
		if ((this.collection.root().get('type') == 'program') && (this.collection.root().get('locked') === 1)) {
			// leave the course list container intact
		} else {
			$('.schema > .course-list-container:eq(0)').remove();
		}
	}
});


/**
 * An Acalog view of locked cores (shared cores), that uses a recursive template
 * instead of initializing sub-views.
 * Template: staticCurriculum.mustache
 */
Curriculog.AcalogStaticCoreView = Backbone.View.extend({
	_events: {
		'click .core-header': 'showHideCore',
		'click .core-header > .btn-delete': 'delete',
	},

	events: function () {
		// FIXME: If we didn't have to call the superclass by name, then this
		// method could be inheritable. Right now it's duplicated in each class.
		var proto = Curriculog.BaseCurriculum.prototype;
		var superEvents = _.result(proto, 'events');
		return _.extend(superEvents, this._events);
	},

	initialize: function(options) {
		this.parentView = options.parentView;
		this.richText = options.model.collection.richText;
		this.render();
		this.listenTo(this.model, 'change', this.render);
		this.listenTo(this.model, 'destroy', this.remove);
	},

	render: function () {
		var data = {cores: this.model.trackedHierarchy()};
		var partials = _.pick(templates, [
			'acalogStaticCoreList',
			'staticCourseList',
			'staticCourse',
			'staticCustomText',
		]);

		el = templates.acalogStaticCore.render(data, partials);
		this.setElement(el);
		this.$el.data('view', this);

		// if rich text, add ckeditor class to shared core
		if (this.richText) {
			this.$('.core-description-field').addClass('ckeditor');
		}
	},

	delete: function (event) {
		event.stopImmediatePropagation();
    new Curriculog.ConfirmCoreDeleteDialog({
      model: this.model,
      parentView:this
    });
	},

	showHideCore: function (event) {
		event.stopImmediatePropagation();
		$(event.target)
			.parents('.core')
			.eq(0)
			.toggleClass('collapsed');
		verticalStretch();
	},

	/** Stub for uniformity between core interfaces */
	hasUnsavedChanges: function () {
		return false;
	},

	save: function () {
		return $.when();
	},

	domParent: function () {
		var parentCore = this.$el.parent().closest('.core');
		if (parentCore.length) {
			return this.model.collection.get(parentCore.data('id'));
		} else {
			return this.model.collection.root();
		}
	}

});



Curriculog.CoreList = Backbone.View.extend({
// TODO: Factor out core from CurriculumView and make a proper core collection.
});




/**
 * CoreView is the view object for curriculum cores.
 * Template: core.mustache
 * Subviews: CoreView, CourseList
 *
 * Note that CoreViews are nested inside other CoreViews, so use
 * `event.stopImmediatePropagation` to prevent events from bubbling up
 * to the parent cores. Also be sure to use `eq(0)` on your jQuery selectors,
 * so you don't select child elements.
 */
Curriculog.CoreView = Backbone.View.extend({
	events: function () {
		var _events = {
			'click .core-header': 'showHide',
			'click .core-header > .btn-delete': 'delete',
			'keyup .core-title-field:eq(0), .core-description-field:eq(0)': 'onKeyup',
			'change .core-title-field:eq(0), .core-description-field:eq(0)': 'onChange'
		};
		// When the proposal is unlaunched we save core fields onblur.
		// When it is active we use buttons to save.
		// Unlaunched state removed. Condition left for history sake.
		if (false && $('#status').val() === 'unlaunched') {
			// Use blur to save core fields.
			_.extend(_events, {
				'blur .core-title-field': 'updateCoreTitle',
				'keypress .core-title-field': 'pressEnterInTitle',
				'blur .core-description-field': 'updateCoreDescription',
			});
		} else {
			// We want to use buttons to save when the proposal is active. The
			// buttons should satisfy the following conditions:
			//   1. the buttons should only appear when the field is focused
			//   2. they should hide when the field is blured
			//   3. or they should hide after button is clicked
			// We have to bind the mouseup event because the click event doesn't
			// get called if the blur event hides the buttons first.
			// So, we have to undelegate the blur event on mousedown, save the
			// field, and then re-delegate the event on mouseup. This will allow
			// showing and hiding the buttons in a way that satisfies the above
			// conditions.
			_.extend(_events, {
				//'blur .core-title-field, .core-description-field': 'hideButtons',
				'mouseup .save-core-title:eq(0)': 'updateCoreTitle',
				'mouseup .save-core-description:eq(0)': 'updateCoreDescription',
				'mouseup .cancel-core-edit': 'cancelEdit',
				//'mousedown .save-core-title, .save-core-description, .cancel-core-edit': 'disableBlur',
				//'mouseup .save-core-title, .save-core-description, .cancel-core-edit': 'restoreBlur',
				'focus .core-title-field, .core-description-field': 'showButtons',
			});
		}
		return _events;
	},

	initialize: function (options) {
		this.parentView = options.parentView;
		// rich text is being set as an option on the collection
		this.richText = options.model.collection.richText;
		this.core_list = [];
		this.ckeditor = null;
		this.render();

		// If we don't call this after the render, then some cores won't
		// listen to this event. It's weird, but I think it's because
		// we are nesting cores within cores.
		this.listenTo(this.model, 'change', this.render);
		this.listenTo(this.model, 'destroy', this.remove);
	},

	render: function () {
		var data = this.model.toJSON();
		var el;


		var old_title = this.$('.core-title-field:eq(0)').val();
		var old_desc = this.$('.core-description-field:eq(0)').val();

		// FIXME: Can this be refactored with .replaceWith?
		var el = templates.core.render(data);
		if (this.el.tagName === 'DIV') {
			// el has not been set, so this is the initial render
			this.setElement(el);
		} else {
			// Re-render
			var oldel = this.el;
			this.setElement(el);
			this.$el.insertAfter(oldel);
			$(oldel).remove();
		}

		if (old_title !== undefined) {
			this.$('.core-title-field:eq(0)').val(old_title);
		}
		if (old_desc !== undefined) {
			this.setDescValue(old_desc);
		}

		this.$el.data('view', this);

		// Subviews.
		this.renderCourseList();
		this.renderSubCores();

		// Hide or remove the core field buttons depending on the status of the
		// proposal.
		var buttons = this.$('.core-description-buttons, .core-title-buttons');
		// Unlaunched state removed. Condition left for history sake.
		if (false && $('#status').val() === 'unlaunched') {
			buttons.remove();
		} else {
			buttons.hide();
		}

		return this;
	},

	renderCourseList: function () {
		var courseList = new Curriculog.CourseList({
			model: this.model,
			parentView: this,
		});
		this.$('.core-content').append(courseList.el);
	},

	renderSubCores: function () {
		var i, coreView,
			subCores = this.model.subCores();
		this.core_list = [];
		for (i = 0; i < subCores.length; i++) {
			coreView = new Curriculog.CoreView({
				richText: this.richText,
				model: subCores[i],
				parentView: this,
			});
			this.core_list.push(coreView);
			this.$('> ol').append(coreView.el);
		}
	},

	getDescValue: function() {
		if (this.richText && this.ckeditor) {
			return this.ckeditor.getData();
		} else if (this.richText && !this.ckeditor) {
			return this.$('.core-description-field:eq(0)').html();
		} else {
			return this.$('.core-description-field:eq(0)').val();
		}
	},

	setDescValue: function(value) {
		if (this.richText && this.ckeditor) {
			return this.ckeditor.setData(value);
		} else if (this.richText && !this.ckeditor) {
			return this.$('.core-description-field:eq(0)').html(value);
		} else {
			return this.$('.core-description-field:eq(0)').val(value);
		}
	},

	delete: function (event) {
		event.stopImmediatePropagation();
		new Curriculog.ConfirmCoreDeleteDialog({
			model: this.model,
			parentView: this
		});
	},

	showHide: function (event) {
		if (event) {
			event.stopImmediatePropagation();
		}
		// This is here because CKEditor thinks it knows what I want.
		// CKEditor should die.

		if (this.$el.hasClass('collapsed')) {
			this.$el.removeClass('collapsed');
			this.enableRichText();

		} else {
			this.$el.addClass('collapsed');
			this.disableRichText();
		}


		// FIXME
		verticalStretch();
	},

	enableRichText: function () {
		if (!this.richText) {
			return;
		}
		var el = this.$('.core-description-field:eq(0)');
		// If CKEditor is initialized before the field is visible then it
		// will set contenteditable=false. Check if `:visible` so this
		// doesn't happen.
		if (el.is(':visible')) {
			// For some reason ckeditor will lose its value if we destroy it and recreate it.
			var old_val = this.getDescValue();

			if (this.ckeditor) {
				this.ckeditor.destroy();
			}

			this.ckeditor = CKEDITOR.inline(el[0]);

			this.setDescValue(old_val);
			verticalStretch();

		}
	},

	disableRichText: function () {
		if (this.richText && this.ckeditor) {
			this.ckeditor.destroy();
			this.ckeditor = null;
		}
	},

	/**
	 * Core keyup event handler
	 *
	 * @param   {Event} event
	 */
	onKeyup: function (event) {
		this.detectChanges();
	},

	onChange: function (event) {
		this.detectChanges();
	},

	detectChanges: _.throttle(function(){
		var name_field = this.$('.core-title-field:eq(0)'),
			unsaved_title = name_field.val() != this.model.get('name');

		var unsaved_desc = false;
		if (this.richText && this.ckeditor) {
			unsaved_desc = this.ckeditor.checkDirty();
		} else {
			var desc_field = this.$('.core-description-field:eq(0)');
			unsaved_desc = desc_field.val() != this.model.get('description');
		}

		this._unsaved_changes = unsaved_title || unsaved_desc;
		app.cv.applyUnsavedColor();
	}, 600),

	/**
	 * Master core save. Saves this and all child cores.
	 *
	 * @returns {Promise} Collective promise that completes when this and all children are done saving
	 */
	save: function () {
		// Top down saving. Save this field then all children
		var view = this,
			promises = [],
			data = [];

		var name_field = this.$('.core-title-field:eq(0)'),
			newName = name_field.val(),
			oldName = this.model.get('name');

		var desc_field = this.$('.core-description-field:eq(0)'),
			newDescription = desc_field.val(),
			oldDescription = this.model.get('description');

		var buttons = this.$('.core-description-buttons:eq(0), .core-title-buttons:eq(0)');
		buttons.slideUp(400, verticalStretch);
		this.removeErrors(buttons);

		if (newName != oldName) {
			data.name = newName;
		}

		if (newDescription != oldDescription) {
			data.description = newDescription;
			// this.disableRichText();
		}

		// if there are any changes to be made
		if (typeof data.name != 'undefined' || typeof data.description != 'undefined') {
			promises.push(this.model.save(data, {
				wait: true,
				success: function (data) {
					view._unsaved_changes = false;
					view.$el.removeClass('collapsed');
					// view.enableRichText();
				}
			}))
		}

		promises = promises.concat(_.invoke(this.core_list, 'save'));
		return $.when.apply($, promises);
	},

	hasUnsavedChanges: function () {
		var unsaved_sub_cores = Boolean(_.filter(_.invoke(this.core_list, 'hasUnsavedChanges')).length);
		return this._unsaved_changes || unsaved_sub_cores;
	},

	updateCoreTitle: function (event) {
		event && event.stopPropagation();
		// if (event.type === 'click' || event.type === 'mouseup') {
		// 	// We clicked a button. Hide the buttons.
		// 	$(event.target).parent().slideUp(400, verticalStretch);
		// }
		var field = this.$('.core-title-field:eq(0)');
		var newName = field.val();
		var oldName = this.model.get('name');
		var view = this;

		var buttons = this.$('.core-title-buttons:eq(0)');
		buttons.slideUp(400, verticalStretch);
		this.removeErrors(buttons);

		if (newName !== oldName) {
			return this.model.save({'name': newName}, {
				wait: true,
				error: function (model, response, options) {

					var messages = {
						'response': response.responseText,
						'default': 'There was an error saving the core name.' + errorMsg
					};

					msg_title = getErrorMessage(messages);

					ErrorDialog = Curriculog.WarningDialog.extend({
						title: msg_title['title'],
						message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
					});
					new ErrorDialog();
					field.val(oldName);
				},
				success: function (data) {
					view.detectChanges();
					view.$el.removeClass('collapsed');
					view.enableRichText();
				}
			});
		}
		return $.when();
	},

	pressEnterInTitle: function (event) {
		event.stopPropagation();
		// Update when ENTER or TAB is pressed
		if (event.which === 13 || event.which === 9) {
			this.updateCoreTitle(event);
			this.$('.core-description-field:eq(0)').focus();
		}
	},

	_updateCoreDescription: function (event) {
		event && event.stopPropagation();
		var view = this;
		var field = this.$('.core-description-field:eq(0)');
		var newDescription = field.val();
		var oldDescription = this.model.get('description');

		var buttons = this.$('.core-description-buttons:eq(0)');

		buttons.slideUp(400, verticalStretch);
		this.removeErrors(buttons);

		if ((oldDescription !== newDescription) && (! $('.cke_dialog:visible, .cke_panel:visible').length))  {
			this.disableRichText();
			return this.model.save({'description': newDescription}, {
				wait: true,
				error: function (model, response, options) {

					var messages = {
						'response': response.responseText,
						'default': 'There was an error saving the core description.' + errorMsg
					};

					msg_title = getErrorMessage(messages);

					ErrorDialog = Curriculog.WarningDialog.extend({
						title: msg_title['title'],
						message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
					});
					new ErrorDialog();

					// We must check to see if the container is an input or a div
					if (view.richText) {
						field.html(oldDescription);
					} else {
						field.val(oldDescription);
					}
				},
				success: function (data) {
					view.$el.removeClass('collapsed');
					view.enableRichText();
					if (view.richText && view.ckeditor) {
						view.ckeditor.resetDirty();
					}
					view.detectChanges();
				}
			});
		}
		return $.when();
	},

	removeErrors: function (buttons) {
		buttons.find('.error').remove();
		var curriculum = buttons.closest('.curriculum'),
			other_errors = curriculum.find('.error');

		if (!other_errors.length) {
			curriculum.removeClass('invalid');
		}
	},

	/* THIS IS A TERRIBLE HACK - here for firefox for unlaunched proposals
		which lose focus and save when clicking toolbar buttons
	*/
	updateCoreDescription: function (event) {
		event && event.stopPropagation();
		setTimeout(_.bind(this._updateCoreDescription, this), 1500);
	},

	cancelEdit: function (event) {
		event && event.stopImmediatePropagation();

		var target = $(event.target),
			textField = target.parent().prev();

		// Restore the original value.
		if (textField.hasClass('core-title-field')) {
			textField.val(this.model.get('name'));

		} else if (textField.hasClass('core-description-field')) {
			this.setDescValue(this.model.get('description'));
			if (this.richText && this.ckeditor) {
				this.ckeditor.resetDirty();
			}
		}
		var buttons = target.parent();
		buttons.slideUp(400, verticalStretch);
		this.removeErrors(buttons);
		this.detectChanges();
	},

	showButtons: function (event) {
		if (app.formView && app.formView.model.get('status') == 'unlaunched') {
			return;
		}
		$(event.target).next().slideDown(400, verticalStretch);
	},

	hideButtons: function (event) {
		$(event.target).next().slideUp(400, verticalStretch);
	},

	disableBlur: function (event) {
		event.stopImmediatePropagation();
		this.$el.undelegate('.core-title-field, .core-description-field', 'blur');
	},

	restoreBlur: function (event) {
		event.stopImmediatePropagation();
		this.$el.delegate('.core-title-field, .core-description-field', 'blur', this.hideButtons);
		$(event.target).parent().slideUp(400, verticalStretch);
	},

	// FIXME: It seems like there is a better way to do this.
	// These methods below are using a combination of the DOM (jq selectors),
	// data attributes and the backbone models to generate the data we need.
	// We need a better data structure to track this state.
	//
	// A list-view could keep track of all it's item sub-views. That way we can
	// just traverse up to the parent view and look in the list to get a sibling
	// itemview.
	// Perhaps this list(-like object) could also be responsive, so that when
	// we append a view, it will add the view to it's list of sub-views.
	// Marionette.js does something similar with the backbone.babysitter lib.

	/**
	 * Look at the DOM and find the parent Core if there is one and return the
	 * cooresponding model.
	 * If there is no parent core, then return the program.
	 */
	domParent: function () {
		var parentCore = this.$el.parent().closest('.core');
		if (parentCore.length) {
			return this.model.collection.get(parentCore.data('id'));
		} else {
			return this.model.collection.root();
		}
	}
},{
	// This object defines the static methods.

	/**
	 * Given a model, find the corresponding view and figure out the children
	 * by looking at the DOM.
	 */
	domChildren: function (model) {
		// XXX: can we use .parentView and get rid of all this selecting?
		var selector, type = model.get('type');
		var sharedCore = (type === 'core' && model.get('locked') === true);
		if (type === 'program' || sharedCore) {
			selector = '.schema > .core-list > .core';
		} else if (type === 'core') {
			selector = '#core-' + model.get('id') + ' > ol > .core';
		} else {
			throw Error('model type must be either "core" or "program".');
		}
		return $(selector).map(function () {
			return $(this).data('id');
		}).toArray();
	},
});



/**
 * AddCoreCourseDialog
 * Template: addCoreCourseDialog.mustache
 */
Curriculog.AddCoreCourseDialog = Curriculog.Dialog.extend({
	title: 'Choose courses to add',
	modal: true,
	buttons: {
		'Add Course': 'addCourse',
		'Cancel': 'close'
	},
	dialogClass: "curriculog-dialog add-core-course-dialog",

	// Don't allow courses to be added to the course-list twice.
	// TODO: move this into an Acalog specific class.
	courses: function () {
		return _.chain(this.model.collection.courses())
			.difference(this.model.courseList())
			.sortBy(function (course) {
				return course.displayName();
			})
			.invoke('toJSON')
			.value();
	},

	render: function () {
		var data = {
			courses: this.courses()
		};
		this.$el.append(templates.addCoreCourseDialog.render(data));
		this.$('.selectable-course-list').multiSelectable();
		this.$el.dialog(this._dialogDefaults());

		// We add this class to make the list items selectable.
		this.$el.closest('.ui-widget-content').addClass('single-field active');

		// The length of the data list throws off the calculation of the top of the viewport
		// on initial render. Recenter after dialog is created
		this.$el.dialog('option', 'position', ['center', 'center']);

		return this;
	},

	addCourse: function () {
		var field = this.$('.select-field.active');
		var children = field.map(function () {
			return $(this).data('id');
		}).toArray();

		var view = this;
		var oldChildren = this.model.get('children');
		this.model.addChild(children).save(null, {
			wait: true,
			error: function (model, response, options) {

				var messages = {
						'response': response.responseText,
						'default': 'There was an error adding a new course to a core.' + errorMsg
					};

				msg_title = getErrorMessage(messages);

				ErrorDialog = Curriculog.WarningDialog.extend({
					title: msg_title['title'],
					message: msg_title['msg'],
					buttons: {
						'Continue': 'close',
					}
				});
				new ErrorDialog();
				model.set('children', oldChildren);
				field.val(oldChildren);
			},
			success: function (data) {
				// Reopen the core.
				// FIXME: this smells
				if (view.parentView.parentView.showHide) {
					view.parentView.parentView.showHide();
				}
			}
		});

		this.close();
	},
});


// FIXME: this is being used for adding text and updating text and the code
// is kind of confusing.
/**
 * AddCoreTextDialog
 * Template: addCoreTextDialog.mustache
 */
Curriculog.AddCoreTextDialog = Curriculog.Dialog.extend({
	el: templates.addCoreTextDialog.render(),
	title: 'Add custom text',
	modal: true,
	draggable: false,
	buttons: function () {
		if (this.model.get('type') === 'custom') {
			return {
				'Update': 'updateText',
				'Cancel': 'close'
			};
		}
		return {
			'Add Text': 'addText',
			'Cancel': 'close'
		};
	},

	initialize: function(options) {
		Curriculog.Dialog.prototype.initialize.call(this, options);
		var richText = options.model.collection.richText || false;
		var description;
		var position;
		var credits;
		var name;

		if (this.model.get('type') === 'custom') {
			name = this.model.get('name');
			description = this.model.get('description');
			position = this.model.get('Position');
			credits = this.model.get('credits');
		} else {
			name = '';
			description = '';
			position = 'before';
			credits = '';
		}
		this.$el.find('.input-custom-text').val(description);
		this.$el.find('#adhoc-position').val(position);
		this.$el.find('#adhoc-credits').val(credits);
		this.$el.find('#adhoc-name').val(name);
		if (richText) {
			proposal().initCKEditor(this.$el.find('.input-custom-text'));
			// remove plain-text styles
			this.$el.find('.input-text').removeClass('plain-text');
			this.$el.find('.add-core-text-label').removeClass('plain-text');
		}
	},

	addText: function () {
		var dialog = this;

		// validate form
		this.$el.find('#adhoc-name').removeClass('error');
		$.validity.start();
		this.$el.find('#adhoc-name').assert(function(field){
			return $(field).val().trim().length > 0;
		}, '#{field} is required.');
		var result = $.validity.end();

		if (result.valid === true) {
			var field = this.$el.find('.input-custom-text');
			var credits = this.$el.find('#adhoc-credits');
			var position = this.$el.find('#adhoc-position');
			var name = this.$el.find('#adhoc-name');
			var text = field.val();
			this.model.collection.create({
				proposal: $('#proposalId').val(),
				name: name.val().trim(),
				description: text,
				type: 'custom',
				parents: [this.model.id],
				credits: credits.val().trim(),
				'Position': position.val().trim()
			},{
				success: function (data) {
					var oldChildren = dialog.model.get('children');
					dialog.model.addChild(data.id).save(null, {
						error: function (model, response, options) {

							var messages = {
								'response': response.responseText,
								'default': 'There was an error adding custom text to a core.' + errorMsg
							};

							msg_title = getErrorMessage(messages);

							ErrorDialog = Curriculog.WarningDialog.extend({
								title: msg_title['title'],
								message: msg_title['msg'],
								buttons: {
									'Continue': 'close',
								}
							});
							new ErrorDialog();
							model.set('children', oldChildren);
						}
					});
					// FIXME: This smells
					if (dialog.parentView.parentView.showHide) {
						dialog.parentView.parentView.showHide();
					}
				},
				error: function (model, response, options) {

					var messages = {
						'response': response.responseText,
						'default': 'There was an error adding custom text to a core.' + errorMsg
					};

					msg_title = getErrorMessage(messages);

					ErrorDialog = Curriculog.WarningDialog.extend({
						title: msg_title['title'],
						message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
					});
					new ErrorDialog();
				}
			});
			this.close();
		} else {
			this.$el.find('#adhoc-name').addClass('error');
		}
	},

	updateText: function () {
		var dialog = this;

		// validate form
		this.$el.find('#adhoc-name').removeClass('error');
		$.validity.start();
		this.$el.find('#adhoc-name').assert(function(field){
			return $(field).val().trim().length > 0;
		}, '#{field} is required.');
		var result = $.validity.end();

		if ( result.valid === true ) {
			var field = this.$el.find('.input-custom-text');
			var newName = this.$el.find('#adhoc-name').val();
			var oldName = this.model.get('name');
			var newDescription = field.val();
			var oldDescription = this.model.get('description');
			var newPosition = this.$el.find('#adhoc-position').val();
			var oldPosition = this.model.get('Position');
			var newCredits = this.$el.find('#adhoc-credits').val();
			var oldCredits = this.model.get('credits');

			var newCoreTextModel = {};

			if ( newName !== oldName ){
				newCoreTextModel['name'] = newName;
			}
			if ( newDescription !== oldDescription ){
				newCoreTextModel['description'] = newDescription;
			}
			if ( newPosition !== oldPosition ){
				newCoreTextModel['Position'] = newPosition;
			}
			if ( newCredits !== oldCredits ){
				newCoreTextModel['credits'] = newCredits;
			}


			if ( _.isEmpty(newCoreTextModel) === false ){
				this.model.save(newCoreTextModel, {
					error: function (model, response, options) {

						var messages = {
							'response': response.responseText,
							'default': 'There was an error updating the custom text.' + errorMsg
						};

						msg_title = getErrorMessage(messages);

						ErrorDialog = Curriculog.WarningDialog.extend({
							title: msg_title['title'],
							message: msg_title['msg'],
							buttons: {
								'Continue': 'close',
							}
						});
						new ErrorDialog();
						model.set('description', oldDescription);
						field.val(oldDescription);
					},
					done: function (data) {
						// FIXME: This smells
						if (dialog.parentView.parentView.showHide) {
							dialog.parentView.parentView.showHide();
						}
					}
				});
			}

			this.close();
		} else {
			this.$el.find('#adhoc-name').addClass('error');
		}
	},

	submitOnEnter: function (event) {
		if (event.which === 13) {
			event.preventDefault();
			if (this.model.get('type') === 'custom') {
				return this.updateText();
			}
			return this.addText();
		}
	}
});

/**
 * ConfirmCoreDeleteDialog
 */
Curriculog.ConfirmCoreDeleteDialog = Curriculog.Dialog.extend({
	title: 'Confirm Delete',
	message: '<p>Are you sure you want to delete this core?</p>',
	dialogClass: 'curriculog-dialog warning',
	modal: true,
	buttons: {
		'Delete Core': 'deleteCore',
		'Cancel': 'close'
	},
	deleteCore: function() {
    var that = this;
		var parentView = this.parentView.parentView;
    var schemaView = parentView.$el.parents('.schema');
		var parentModel = parentView.model;
		var core = this.model;
		var coresToDelete = [];
    /***
     destroyCores
     Takes an array of objects containing references to the core to be deleted
     and its parent that needs to be updated. Will recusively run until array
     length is 0.
     coresToDelete {Object[]} - list of cores to delete in order from most nested
     to first level
     ***/
    var destroyCores = function(coresToDelete) {
      if (coresToDelete.length > 0) {
        var coreToDelete = coresToDelete.shift();
        var core = coreToDelete.core;
        var parent = coreToDelete.parent;
        var coreId = core.id;
        core.destroy({
          error: function(model, response, options) {
            var messages = {
              'response': response.responseText,
              'default': 'There was an error deleting the core.' + errorMsg
            };

            msg_title = getErrorMessage(messages);

            ErrorDialog = Curriculog.WarningDialog.extend({
              title: msg_title['title'],
              message: msg_title['msg'],
              buttons: {
                'Continue': 'close',
              }
            });
            new ErrorDialog();
          },
          success: function(data) {
            parent.removeChild(coreId, {silent: true}).save(null, {
              success: function(data) {
                destroyCores(coresToDelete);
              }
            });
          }
        });
      } else {
        parentView.$el.unmask();
      }
    };

    /***
     * recursiveCoreDelete
     * creates an ordered list of cores to be deleted by recusrively traversing
     * core user selected for deletion
     ***/
    var recursiveCoreDelete = function(core, parent) {
      childrenIds = core.get('children');
      var children = [];
      _.each(childrenIds, function(childId) {
        var child = core.collection.get(childId);
        if (child.get('type') === 'core') {
          children.push(child);
        }
      });
      if (children.length === 0) {
        var coreToDelete = {
          core: core,
          parent: parent
        };
        coresToDelete.push(coreToDelete);
        return;
      }
      _.each(children, function(child) {
          recursiveCoreDelete(child, core);
      });
      coresToDelete.push({
        core: core,
        parent: parent
      });
    };
		parentView.$el.mask('Loading...');
    recursiveCoreDelete(core, core.parent());
    destroyCores(coresToDelete);
    that.close();
	}
});




/**
 * CurriculumPreview displays a static view of the curriculum schema (the cores
 * and their courses hierarchically).
 */
 Curriculog.CurriculumPreview = Backbone.View.extend({
	initialize: function (options) {
		this.listenTo(this.collection, 'reset', this.render);
		this.collection.fetch({reset: true});
		this.options = options;
	},

	render: function () {


		if (this.collection && typeof this.collection.root() !== 'undefined') {

			var rootModel = this.collection.root();
			var data = rootModel.trackedHierarchy();

			var partials = {'core-list': templates.previewCoreList};
			if (rootModel.get('locked') === 1) {
				partials = {'core-course-list': templates.previewCoreCourses, 'core-list': templates.previewCoreList};
			}

			var cores = data.cores;
			this.sanitizeCurriculum(cores);

			var el = $(templates.previewCurriculum.render(data, partials));
			this.$el.replaceWith(el);
			this.setElement(el);
			this.$el.parents('body').unmask();
		} else {
			$('body').unmask();
		}
	},

	sanitizeCurriculum: function (cores) {

		for (var i = 0; i < cores.length; i++) {
			var core = cores[i];
			var courses = core.courses;

			if (core !== undefined) {
				this.replaceTag(core);
			};

			if (courses !== undefined) {
				this.sanitizeCourses(courses);
			};

	};

	},

	sanitizeCourses: function (courses) {

		for (var i = 0; i < courses.length; i++) {

			this.replaceTag(courses[i]);

		};

	},

	replaceTag: function (courseCore){

		tags = {
			'<script>' : '&lt;script&gt;',
			'</script>' : '&lt;/script&gt;',
			'<SCRIPT>' : '&lt;SCRIPT&gt;',
			'</SCRIPT>' : '&lt;/SCRIPT&gt;'
		};

		fields = ['name', 'prefix', 'code', 'displayName', 'description', 'displayDescription', 'displayCredits'];

		for (key in courseCore) {
			if (fields.includes(key) && courseCore[key]){
				for(tag in tags){
					courseCore[key]  = courseCore[key] .replaceAll(tag, tags[tag]);
				}
			};
		};

	}

	});




/**
 * A base View for course-list items.
 */
Curriculog.CourseListItem = Backbone.View.extend({
	initialize: function (options) {
		this.parentView = options.parentView;
		this.listenTo(this.model, 'change', this.render);
		this.render();
	},

	render: function () {
		var data = this.model.toJSON();
		data.description = data.description;
		if (data.type === 'custom') {
			data.description = tracking().nl2br(data.description);
		}

		var el = $(this.template.render(data));
		this.$el.replaceWith(el);
		this.setElement(el);
		return this;
	},

});




Curriculog.CoreCourse = Curriculog.CourseListItem.extend({
	template: templates.course,
	events: {
		'click .delete-course': 'destroy',
	},
	destroy: function () {
		// If we don't silence the change event then the core will rerender and
		// close.
		var courseList = this.parentView.parentView.model.get('children');
		custom_core = 0;
		course_core = 0;

		var i, model;
		for (i = 0; i < courseList.length; i++) {
			model = this.parentView.parentView.model.collection.get(courseList[i]);
			var type = model.get('type');

			if (type == 'course') {
				course_core ++;
			}
			if (type == 'custom') {
				custom_core ++;
			}
		}

		if((custom_core >= 1) && (course_core == 1)){
			var msg = 'This core also has custom text. At least one course ' +
					'must exist for a custom text to be associated with a core. ' +
					'To delete this course, you must first remove the custom text from this core.';

			new Curriculog.Dialog({
				title: 'The course can not be deleted.',
				message: '<center>' + msg + '</center>',
				dialogClass: 'curriculog-dialog warning'
			});
		} else {
			var view = this;
			var course = this.model;
			var courseID = course.get('id');
			var oldChildren = this.parentView.model.get('children');
			var parent = this.parentView;
			parent.$el.mask('Loading...');
			this.parentView.model.removeChild(courseID, {silent: true}).save(null, {
				error: function (model, response, options) {
					var messages = {
						'response': response.responseText,
						'default': 'There was an error deleting the course.' + errorMsg
					};

					msg_title = getErrorMessage(messages);

					wait: true,
					ErrorDialog = Curriculog.WarningDialog.extend({
						title: msg_title['title'],
						message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
					});
					new ErrorDialog();
				},
				success: function (data) {
					view.remove();
					// because this is used by program core course lists and
					// shared core root course list, we have to look at the children
					// models and not count cores
					var courseChildren = view.parentView.model.children('course');
					var courseListDom = view.parentView.$el.find('.course-list');
					if (courseChildren.length === 0 && courseListDom.find('.empty-list').length === 0) {
						courseListDom.append('<li class="empty-list">No Courses</li>');
					}
					view.parentView.$el.unmask();
				}
			});
		}
	},
});




Curriculog.CoreCustomText = Curriculog.CourseListItem.extend({
	template: templates.customText,
	events: {
		'click .delete-course': 'destroy',
		'click .edit-course': 'edit'
	},

	edit: function (event) {
		event.stopImmediatePropagation();
		new Curriculog.AddCoreTextDialog({
			model: this.model,
			parentView: this
		});
	},
	destroy: function () {
		var view = this;
		var custom = this.model;
		var customID = custom.get('id');
		this.model.destroy({
			wait: true,
			error: function (model, response, options) {
				var messages = {
						'response': response.responseText,
						'default': 'There was an error deleting the custom text.' + errorMsg
					};

				msg_title = getErrorMessage(messages);

				ErrorDialog = Curriculog.WarningDialog.extend({
					title: msg_title['title'],
					message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
				});
				new ErrorDialog();
			},
			success: function (data) {
				view.parentView.model.removeChild(customID, {silent: true}).save();
				view.remove();
			}
		});
	}

		// AL: this was in issue-500, which was behind the curriculum-error branch
		// Can't tell from git if this was old or she changed it.

		// If we don't silence the change event then the core will rerender and
		// close.
		// var id = this.model.get('id');
		// this.parentView.model.removeChild(id, {silent: true}).save();
		// this.model.destroy();
		// this.remove();

});




/**
 * CourseList is a list for courses. It is used in CurriculumView for the root
 * course-list and in CoreView for the core course-list.
 * Subviews: AddCoreCourseDialog, AddCoreTextDialog, CoreCourse, CoreCustomText
 * ParentViews: CurriculumView, CoreView
 */
Curriculog.CourseList = Backbone.View.extend({
	el: templates.courseList.render(),
	events: {
		'click .add-core-course': 'addCourses',
		'click .add-core-text': 'addCustomText',
		'sortupdate': 'sortItem',
		'sortstart': 'beforeSort'
	},

	initialize: function (options) {
		this.parentView = options.parentView;
		// FIXME: if this is the root course-list then we don't have a model,
		// because we rendered this view before we set the model, so, we need
		// to find the correct model. This could be fixed by rendering after
		// we set the model.
		if (!this.model) {
			this.model = this.parentView.collection.root();
		}
		this.render();
	},

	render: function () {
		var courseList = this.model.courseList();
		if (courseList.length) {
			_.each(courseList, this.addItem, this);
		} else {
			this.appendHTML('<li class="empty-list">No Courses</li>');
		}
		this.sortable();
	},

	sortable: function () {
		this.$('.course-list').sortable({
			item: 'li.course',
			placeholder: 'ui-state-highlight',
			// containment: 'parent',
			tolerance: 'pointer'
		});
	},

	addItem: function (model) {
		var itemView;
		var type = model.get('type');
		if (type === 'course') {
			itemView = Curriculog.CoreCourse;
		} else if (type === 'custom') {
			itemView = Curriculog.CoreCustomText;
		}

		var item = new itemView({
			parentView: this,
			model: model
		});

		this.appendHTML(item.el);
	},

	appendHTML: function (el) {
		this.$('.course-list').append(el);
	},

	addCourses: function (event) {
		event.stopImmediatePropagation();
		new Curriculog.AddCoreCourseDialog({
			model: this.parentView.model,
			parentView: this
		});
	},


	addCustomText: function (event) {
		event.stopImmediatePropagation();
		var courseList = this.model.courseList();
		if (courseList.length) {
			new Curriculog.AddCoreTextDialog({
				model: this.parentView.model,
				parentView: this
			});
		}else{
			new Curriculog.Dialog({
				title: 'A custom text cannot be added',
				message: 'You must add a course before you may add custom text.',
				dialogClass: 'curriculog-dialog warning'
			});
		}
	},

	beforeSort: function (event, ui) {
		var targetItem = $(ui.item);
		var targetID = targetItem.data('id');
		var listItems = targetItem.parent().children().toArray();
		this.oldItemIDs = listItems.map(function (item) {
				return + item.dataset.id;
			});
	},

	sortItem: function (event, ui) {
		event.stopImmediatePropagation();
		var targetItem = $(ui.item),
			targetID = targetItem.data('id'),
			targetItems = targetItem.parent().children(),
			listItems = targetItems.toArray(),
			itemIDs = listItems.map(function (item) {
				return + item.dataset.id;
			});
		// Send the target of the sort so the backend can know what item was
		// sorted for user tracking, but then remove it from the model so it's
		// not sent with subsequent updates.
		var view = this;
		var silent = {silent: true};
		this.model.set('target', targetID, silent);
		this.model.updateCourseList(itemIDs, silent).save(null, {
			error: function (model, response, options) {
				var messages = {
						'response': response.responseText,
						'default': 'There was an error sorting the courses.' + errorMsg
					};

				msg_title = getErrorMessage(messages);

				ErrorDialog = Curriculog.WarningDialog.extend({
					title: msg_title['title'],
					message: msg_title['msg'],
					buttons: {
						'Continue': 'close',
					}
				});
				new ErrorDialog();
				targetItems.remove();
				view.model.updateCourseList(view.oldItemIDs, silent);
				view.render();
			},
		});
		this.model.unset('target', silent);
	},
});



/**
 * The item-view for the course bucket.
 * Template: course.mustache
 */
Curriculog.CourseBucketItem = Curriculog.CourseListItem.extend({
	template: templates.course,
	events: {
		'click .delete-course': 'destroy',
	},

	/**
	 * Delete the course only if it's not a child of a core, in which case
	 * pop a dialog that shows the cores using the course.
	 */
	destroy: function () {
		var course = this;
		var cores = this.model.collection
			.where({type:'core'})
			.filter(function (model) {
				return _.contains(model.get('children'), course.model.id);
			});

		var programCore = this.model.collection.root().children('course');
		var programCoreIds = _.pluck(programCore, 'id');


		var coreNames =  _.invoke(cores, 'get', 'name');
		var message = '<p>This course must be removed from the following ' +
					'cores before deleting: </p>' +
					'<ul><li>' + coreNames.join('</li><li>') + '</li></ul>';

		if (cores.length) {
			new Curriculog.Dialog({
					title: 'This course cannot be removed',
					message: message,
					dialogClass: 'course-delete-dialog'
				});

		} else if (_.contains(programCoreIds, course.model.id)) {
			new Curriculog.Dialog({
					title: 'This course cannot be removed',
					message: '<center>This course must be removed from the shared core course list before deleting.</center>',
					dialogClass: 'course-delete-dialog'
				});

		} else {
			var view = this;
			this.$el.hide();
			this.model.destroy({
				error: function (model, response, options) {
					var messages = {
						'response': response.responseText,
						'default': 'There was an error deleting the course.' + errorMsg
					};

					msg_title = getErrorMessage(messages);

					ErrorDialog = Curriculog.WarningDialog.extend({
						title: msg_title['title'],
						message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
					});
					new ErrorDialog();
					this.$el.show();
				},
				success: function (data) {
					// test
					var courseList = course.parentView.collection.where({type:'course'});
					view.$el.remove();
					if(courseList.length == 0)
						course.parentView.$('.course-list').append('<li class="empty-list">No Courses</li>');

				},
				wait: true
			});
		}
	}
});



function isEmpty(element){
	return ! $(element).val().trim().length;
};

/**
 * A dialog presenting a form to create a new course for the course bucket.
 * Template: newCourseDialog.mustache
 */
Curriculog.NewCourseDialog = Curriculog.Dialog.extend({
	el: templates.newCourseDialog.render(),
	modal: true,
	buttons: {
		'Add Course': 'addCourse',
		'Cancel': 'close'
	},

	isValid: function () {
		var fields = this.$el.find('input[name="prefix"], input[name="code"], input[name="name"]');
		var empty_fields = _.filter(fields, isEmpty);

		// Remove pre-existing errors
		this.$el.find('.error').remove();

		_.map(empty_fields, function(field) {
			$("<span class='error'>This field is required</span>").insertAfter(field);
		});

		return ! Boolean(empty_fields.length);
	},

	addCourse: function () {
		if(this.isValid()){
			var course = {
				prefix: this.$('input[name="prefix"]').val(),
				code: this.$('input[name="code"]').val(),
				name: this.$('input[name="name"]').val(),
				proposal: $('#proposalId').val(),
				type: 'course'
			};
			this.collection.create(course, {
				wait: true,
				error: function (model, response, options) {

					var messages = {
						'response': response.responseText,
						'default': 'There was an error creating the course.' + errorMsg
					};

					msg_title = getErrorMessage(messages);

					ErrorDialog = Curriculog.WarningDialog.extend({
						title: msg_title['title'],
						message: msg_title['msg'],
						buttons: {
							'Continue': 'close',
						}
					});
					new ErrorDialog();
				}
			});
			this.close();
		}
	}
});


function getErrorMessage(messages) {

	if (messages['response'].match(/You are not authorized to access this resource/)) {

		var msg_title = {
			'msg':  'The proposal status may have changed since you started editing. Please reload this page.',
			'title': 'Unauthorized'
		}

	}
	else {

		var msg_title = {
			'msg':  messages['default'],
			'title': 'Warning'
		}
	}

	return msg_title;
}




/**
 * View for the course bucket. A list view that contains all the courses.
 * Template: courseBucket.mustache
 * Subviews: NewCourseDialog, CourseBucketItem
 * ParentViews: CurriculumView
 */
Curriculog.CourseBucket = Backbone.View.extend({
	el: templates.courseBucket.render(),
	itemView: Curriculog.CourseBucketItem,
	events: {
		'click .add-course': 'addCourseDialog',
		'click .import-course': 'importCourse',
		'click .done': 'reloadStaticView'
	},

	initialize: function (options) {
		this.parentView = options.parentView;
		this.fieldView = options.fieldView;
		this.listenTo(this.parentView.collection, 'add:course', this.addCourse);
		this.render(); // Should we listen to collection for reset?
	},

	render: function () {
		var courseList = this.collection.courses();
		if (courseList.length) {
			_.each(this.collection.courses(), this.addCourse, this);
		} else {
			this.appendHTML('<li class="empty-list">No Courses</li>');
		}
	},

	addCourseDialog: function () {
		return new Curriculog.NewCourseDialog({
			parentView: this,
			collection: this.collection,
      title: 'Add Course'
		});
	},

	addCourse: function (model) {
		var courseView = new this.itemView({
			model: model,
			parentView: this
		});
		this.appendHTML(courseView.el);
		verticalStretch();
		emptyListLenght = courseView.parentView.$('.empty-list').length;
		if (emptyListLenght != 0)
			courseView.parentView.$('.empty-list').remove();

		return courseView;
	},

	/**
	 * Append the itemView el in alphabetical order.
	 * @param  {HTMLLIElement} el -- an <li>.
	 * TODO: We should not be doing any sorting logic based off the DOM. This makes
	 * this function prone to breaking whenever the template is changed.
	 */
	appendHTML: function (el) {
		var list = this.$('.course-list'),
			children = list.children(),
			child, childText;
		var elText = '';
		if (el.innerHTML) {
			var elCourseName = el.getElementsByClassName('course-name');
			elText = elCourseName.length > 0 ? elCourseName[0].innerHTML.toLowerCase() : '';
		}
		for (var i = 0; i < children.length; i++) {
			child = children[i];
			var childCourseName = child.getElementsByClassName('course-name');
			childText = childCourseName.length > 0 ? childCourseName[0].innerHTML.toLowerCase() : '';
			if (childText > elText) {
				$(el).insertBefore(child);
				return;
			}
		}
		list.append(el);
		// TODO: since we insert the item in anywhere in the list, we need to
		// highlight the item after we insert.
		// Why won't this work?
		// $(el).show({effect: 'highlight', duration: 3000});
	},

	importCourse: function () {
		var params = {
			display: 'hermesAvailableLegend',
			method: 'cart',
			systemItemId: $('#approvalProcessId').val(),
			type: 'course',
			id: 0,
			proposalId: $('#proposalId').val(),
			subType: ''
		};
		var url = '/hermes?' + $.param(params);
		return hermesObject.loadWindow(url);
	},

	reloadStaticView: function (event) {
		this.fieldView.cancel(event);
	},
});


/***
 * Curriculog.BackgroundCurriculumPreview
 * Because the curriculum preview with markup is being fetched via gearman
 * we do not need to fetch from the backbonejs collection, so we use this
 * view to bypass that.
 ***/
Curriculog.BackgroundCurriculumPreview = Curriculog.CurriculumPreview.extend({
	initialize: function(options) {
		this.options = options;
		this.render();
	}
});
